import React, {FC, useEffect, useState} from 'react'
import {Alert, Modal, Spinner} from 'react-bootstrap'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {resetPasswordValid} from '../Utils/_helpers/ValidationSchema'
import {toast} from 'react-toastify'
import { KTSVG } from '../../_metronic/helpers'

type ChangePasswordPopupProps = {
  show: boolean
  handleSubmit: (password: string) => Promise<{isSuccess: boolean; message: string}>
  handleClose: () => void
}

const ChangePasswordPopup: FC<ChangePasswordPopupProps> = ({show, handleClose, handleSubmit}) => {
  const [passwordType, setPasswordType] = useState({
    password: true,
    confirm: true,
  })

  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    setPasswordType({
      password: true,
      confirm: true,
    })
  }, [show])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Change Password</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 '>
          {errorMessage.length > 0 && (
            <div className='card-toolbar align-items-center'>
              <div className='p-10 pb-0'>
                <Alert variant='danger'>{errorMessage} </Alert>{' '}
              </div>
            </div>
          )}

          <Formik
            initialValues={{
              password: '',
              confirmPassword: '',
            }}
            validationSchema={resetPasswordValid}
            onSubmit={(val, {setSubmitting, resetForm}) => {
              setErrorMessage('')
              handleSubmit(val.password)
                .then((response) => {
                  if (response.isSuccess) {
                    toast.success('success and send new credential your email or parent email')
                    handleClose()
                    resetForm()
                  } else {
                    setErrorMessage(response.message)
                  }
                })
                .catch((error) => {
                  setErrorMessage(`${error}`)
                })
                .finally(() => {
                  setSubmitting(false)
                })
            }}
          >
            {({isSubmitting}) => (
              <Form>
                <div>
                  <label htmlFor='password'>Password</label>
                  <div className='password-wrap'>
                    <Field
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      type={passwordType.password ? 'password' : 'text'}
                      id='password'
                      name='password'
                    />
                    <span
                      className='svg-icon svg-icon-3'
                      onClick={() => {
                        setPasswordType({...passwordType, password: !passwordType.password})
                      }}
                    >
                      {passwordType.password ? (
                        <i className='bi bi-eye-fill'></i>
                      ) : (
                        <i className='bi bi-eye-slash-fill'></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage name='password'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                <div className='my-5'>
                  <label htmlFor='confirmPassword'>Confirm Password</label>
                  <div className='password-wrap'>
                    <Field
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      type={passwordType.confirm ? 'password' : 'text'}
                      id='confirmPassword'
                      name='confirmPassword'
                    />
                    <span
                      className='svg-icon svg-icon-3'
                      onClick={() => {
                        setPasswordType({...passwordType, confirm: !passwordType.confirm})
                      }}
                    >
                      {passwordType.confirm ? (
                        <i className='bi bi-eye-fill'></i>
                      ) : (
                        <i className='bi bi-eye-slash-fill'></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage name='confirmPassword'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                <button className='btn btn-primary'>
                  {isSubmitting ? <Spinner size='sm' animation='grow' /> : 'Change Password'}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(ChangePasswordPopup)
